import React from 'react';
import { TextField, MenuItem } from '@mui/material';
import { useTranslation } from '../../hooks/useTranslation';

/**
 * Location picker for cashier flows. When the tenant has a single active
 * location it is preselected by the parent and rendered read-only.
 */
const LocationSelect = ({ locations, value, onChange, disabled }) => {
  const { t } = useTranslation();
  const active = (locations || []).filter((l) => l.active !== false);
  const single = active.length === 1;

  return (
    <TextField
      select
      fullWidth
      label={t('loyalty.location')}
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled || single}
      required
      helperText={single ? t('loyalty.singleLocationHint') : ''}
    >
      {active.map((l) => (
        <MenuItem key={l.id} value={l.id}>{l.name}</MenuItem>
      ))}
    </TextField>
  );
};

export default LocationSelect;
